import { Navigate } from 'react-router';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_MARKET,
  ANY_SPORT_MARKET_WHEEL_RARITY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useSeriesNav } from '@sorare/core/src/hooks/commonGame/useSeriesNav';
import { useEnabledWheelByRarity } from '@sorare/core/src/hooks/useEnabledWheelByRarity';

const RARITY_PRIORITY: (keyof ReturnType<typeof useEnabledWheelByRarity>)[] = [
  'limited',
  'rare',
  'super_rare',
  'unique',
  'common',
];

export const MarketWheelPage = () => {
  const enabledWheelByRarity = useEnabledWheelByRarity();
  const { generateSportContextPath } = useSportContext();
  const isUsingSeries = useSeriesNav();

  if (!Object.values(enabledWheelByRarity).some(Boolean)) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_MARKET)} replace />;
  }

  let defaultRarity: string | null = null;
  if (isUsingSeries && enabledWheelByRarity.common) {
    defaultRarity = Rarity.common;
  } else {
    for (const rarity of RARITY_PRIORITY) {
      if (enabledWheelByRarity[rarity]) {
        defaultRarity = rarity;
        break;
      }
    }
  }

  if (!defaultRarity) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_MARKET)} replace />;
  }

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MARKET_WHEEL_RARITY, {
        params: {
          rarity: defaultRarity,
        },
      })}
      replace
    />
  );
};

export default MarketWheelPage;
